import { createElement } from 'react';
import cn from 'classnames';
import { Button } from '../Button/index.js';
import styles from 'ui-components/Chip.scss';

var Toggle = function Toggle(_ref) {
  var _cn;
  var active = _ref.active,
    _ref$activate = _ref.activate,
    activate = _ref$activate === void 0 ? function () {} : _ref$activate,
    children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/createElement(Button, {
    className: cn(className, styles.block, (_cn = {}, _cn[styles.active] = active, _cn)),
    onClick: activate
  }, children);
};

export default Toggle;
//# sourceMappingURL=toggle.js.map
